import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const CheckoutModal = ({ isOpen, onClose, product }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCheckout = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/payment/create-checkout-session`,
        { productId: product.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const stripe = await stripePromise;
      const { error } = await stripe.redirectToCheckout({
        sessionId: response.data.sessionId,
      });

      if (error) {
        setError(error.message);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to initiate checkout');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black/50 dark:bg-black/50 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-[#2a2a2a]/90 dark:bg-[#282828]/90 backdrop-blur-sm rounded-lg shadow-lg border border-white/[0.08] dark:border-white/[0.08] w-[600px] h-[auto] flex flex-col">
        <div className="flex-1 p-8">
          <h2 className="text-2xl font-medium text-gray-200 dark:text-white mb-4">Complete Your Subscription</h2>
          
          <div className="bg-gradient-to-r from-blue-500/10 dark:from-blue-500/10 to-purple-500/10 dark:to-purple-500/10 rounded-lg p-6 border border-blue-500/20 dark:border-blue-500/20 mb-6">
            <div className="flex justify-between items-center mb-4">
              <div>
                <h3 className="text-xl font-medium text-gray-200">{product.name}</h3>
                <p className="text-gray-400 mt-1">{product.description}</p>
              </div>
              <div className="text-2xl font-bold text-gray-200 dark:text-white">${product.price}/mo</div>
            </div>
          </div>

          {error && (
            <div className="bg-red-500/10 border border-red-500/20 dark:bg-red-500/10 dark:border-red-500/20 rounded-lg p-4 mb-6">
              <p className="text-red-400">{error}</p>
            </div>
          )}
        </div>

        <div className="flex justify-end items-center px-8 py-6 bg-[#1e1e1e]/80 border-t border-white/[0.08] dark:bg-[#1e1e1e]/80 dark:border-white/[0.08]">
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-md text-gray-200 dark:text-white hover:bg-[#EDEDED]/80 dark:hover:bg-[#282828]/80 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleCheckout}
              disabled={isLoading}
              className="px-6 py-2 bg-blue-500 text-black dark:text-white rounded-md hover:bg-blue-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Processing...' : 'Proceed to Payment'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutModal; 